import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

export interface AppConfig {
  apiUrl: string;
  spotifyClientId?: string;
  googleClientId?: string;
  facebookClientId?: string;
  discogsClientId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configSubject = new BehaviorSubject<AppConfig | null>(null);
  public config$ = this.configSubject.asObservable();

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<AppConfig> {
    return this.http.get<AppConfig>(`${environment.apiUrl}/config`).pipe(
      tap(config => {
        this.configSubject.next(config);
      }),
      catchError((error) => {
        console.error('Error loading config:', error);
        const defaultConfig: AppConfig = {
          apiUrl: environment.apiUrl
        };
        this.configSubject.next(defaultConfig);
        return of(defaultConfig);
      })
    );
  }

  getApiUrl(): string {
    return this.configSubject.value?.apiUrl || environment.apiUrl;
  }
}
